// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202611040105/js/" + chunkId + "." + {"44":"e1a85dd4","225":"40fe5831","481":"327e2fbd","486":"8a18f1b4","770":"d50ead73"}[chunkId] + ".0.2803402659467036.chunk.js";
};